import Captcha from './captcha';
import Input from '../input';
import From from '../form';
import Loading from '../loading';
/* istanbul ignore next */
Captcha.install = function(Vue) {
  Vue.use(Input);
  Vue.use(From);
  Vue.use(Loading);
  Vue.component(Captcha.name, Captcha);
};

export default Captcha;
